import { useEffect } from "react";
import { io } from "socket.io-client";
import { toast } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";
import { socket_url } from './constants/config';

const user = localStorage.getItem('user')

const socket = io(socket_url, {
    transports: ["websocket"],
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
});

const NotificationHandler = () => {
  useEffect(() => {
    if (!socket.connected) {
      socket.connect();
    }

    if (user) {
        socket.emit("join", user); 
      }

    socket.on("newNotification", (notification) => {
      toast.info(notification.message, { position: "top-center" });
    });

    return () => {
      socket.off("newNotification");
    };
  }, []);

  return null; // No UI, just listens for notifications
};

export default NotificationHandler;
